
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1xLOH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $9VJDA = parcelRequire("9VJDA");


var $6xdDU = parcelRequire("6xdDU");


var $3gadb = parcelRequire("3gadb");


var $jdPfT = parcelRequire("jdPfT");


var $inPa6 = parcelRequire("inPa6");


var $tvI67 = parcelRequire("tvI67");


var $iXCQx = parcelRequire("iXCQx");


var $1qfLF = parcelRequire("1qfLF");


var $9x2sR = parcelRequire("9x2sR");


var $iKHTh = parcelRequire("iKHTh");


var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");


var $dPJCf = parcelRequire("dPJCf");


var $b8XTE = parcelRequire("b8XTE");


var $7aA9P = parcelRequire("7aA9P");


var $4vC63 = parcelRequire("4vC63");


var $jmjWc = parcelRequire("jmjWc");


var $j3kZx = parcelRequire("j3kZx");


var $e4o8D = parcelRequire("e4o8D");


var $aWrnw = parcelRequire("aWrnw");


var $cpa7E = parcelRequire("cpa7E");


var $AF127 = parcelRequire("AF127");

const $68bf5bd74b4d15cf$export$1f48dee9216ef30e = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { isSpaceAdmin: isSpaceAdmin, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            sectionName: "apps"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)(t1);
    const [isOpenAppsConfiguration, setOpenAppsConfiguration] = (0, $42omo.useState)(false);
    const hasVisibleAppLinks = allVisibleAppLinks.length !== 0;
    if (allAppLinks.length === 0 || !hasVisibleAppLinks && !isSpaceAdmin) return null;
    let t2;
    if ($[1] !== allVisibleAppLinks) {
        t2 = allVisibleAppLinks.filter($68bf5bd74b4d15cf$var$_temp);
        $[1] = allVisibleAppLinks;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = t2.length;
    let t4;
    if ($[3] !== allVisibleAppLinks) {
        t4 = allVisibleAppLinks.filter($68bf5bd74b4d15cf$var$_temp2);
        $[3] = allVisibleAppLinks;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t2.length || $[6] !== t4.length) {
        t5 = {
            connectApps: t3,
            forgeApps: t4.length
        };
        $[5] = t2.length;
        $[6] = t4.length;
        $[7] = t5;
    } else t5 = $[7];
    const pageSegmentLoadCustomData = t5;
    let t6;
    if ($[8] !== pageSegmentLoadCustomData || $[9] !== spaceKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
            key: spaceKey,
            metric: (0, $aWrnw.SPACE_APPS_METRIC),
            customData: pageSegmentLoadCustomData
        });
        $[8] = pageSegmentLoadCustomData;
        $[9] = spaceKey;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
            label: "",
            color: "currentColor"
        });
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== isSpaceAdmin) {
        t8 = isSpaceAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $68bf5bd74b4d15cf$var$i18n.editButtonTooltip),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $68bf5bd74b4d15cf$var$_temp3,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $68bf5bd74b4d15cf$var$i18n.editButtonLabel),
            onClick: ()=>setOpenAppsConfiguration(true),
            spacing: "compact",
            appearance: "subtle"
        }));
        $[12] = isSpaceAdmin;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $68bf5bd74b4d15cf$var$i18n.title);
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
            elemBefore: t7,
            actionsOnHover: t8
        }, t9);
        $[15] = t8;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== allVisibleAppLinks || $[18] !== hasVisibleAppLinks) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, hasVisibleAppLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, allVisibleAppLinks.map($68bf5bd74b4d15cf$var$_temp4)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $68bf5bd74b4d15cf$var$i18n.noAppsMessage)));
        $[17] = allVisibleAppLinks;
        $[18] = hasVisibleAppLinks;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== isExpanded || $[21] !== onExpansionToggle || $[22] !== t10 || $[23] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
            isExpanded: isExpanded,
            onExpansionToggle: onExpansionToggle,
            testId: "space-apps"
        }, t10, t11);
        $[20] = isExpanded;
        $[21] = onExpansionToggle;
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== allAppLinks || $[26] !== isOpenAppsConfiguration || $[27] !== spaceKey) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpenAppsConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68bf5bd74b4d15cf$var$LazySpaceAppsConfiguration, {
            links: allAppLinks,
            spaceKey: spaceKey,
            onCancel: ()=>setOpenAppsConfiguration(false),
            onSave: ()=>setOpenAppsConfiguration(false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null));
        $[25] = allAppLinks;
        $[26] = isOpenAppsConfiguration;
        $[27] = spaceKey;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t12 || $[30] !== t13 || $[31] !== t6) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t12, t13);
        $[29] = t12;
        $[30] = t13;
        $[31] = t6;
        $[32] = t14;
    } else t14 = $[32];
    return t14;
};
const $68bf5bd74b4d15cf$var$AppLink = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { link: link } = t0;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { id: id, icon: icon, url: url, title: title, type: type, styleClass: styleClass } = link;
    let t1;
    if ($[0] !== url) {
        t1 = {
            selector: (actualUrl)=>actualUrl === url
        };
        $[0] = url;
        $[1] = t1;
    } else t1 = $[1];
    const isMatchingCurrentUrlArgs = t1;
    const matchesUrl = (0, $dPJCf.useRouteUrl)(isMatchingCurrentUrlArgs);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[2] !== createAnalyticsEvent || $[3] !== title) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    source: "sidebar",
                    actionSubjectId: "appLink",
                    attributes: {
                        appTitle: title
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = title;
        $[4] = t2;
    } else t2 = $[4];
    const onClick = t2;
    let t3;
    if ($[5] !== styleClass) {
        t3 = (element)=>{
            if (element === null) return;
            if (typeof styleClass !== "string" || styleClass.length === 0) return;
            const classList = styleClass.split(" ");
            element.classList.add(...classList);
        };
        $[5] = styleClass;
        $[6] = t3;
    } else t3 = $[6];
    const injectStyleClass = t3;
    const t4 = icon?.path;
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            "data-vc": "space-apps-link-icon",
            src: t4,
            width: "16",
            height: "16",
            fallback: $68bf5bd74b4d15cf$var$_temp5,
            role: "presentation"
        });
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = Boolean(url && matchesUrl);
    const t7 = url || "";
    let t8;
    if ($[9] !== id || $[10] !== injectStyleClass || $[11] !== onClick || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            key: id,
            ref: injectStyleClass,
            elemBefore: t5,
            isSelected: t6,
            href: t7,
            onClick: onClick
        }, title);
        $[9] = id;
        $[10] = injectStyleClass;
        $[11] = onClick;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = title;
        $[16] = t8;
    } else t8 = $[16];
    const linkItem = t8;
    let t9;
    if ($[17] !== id || $[18] !== link || $[19] !== linkItem || $[20] !== push || $[21] !== renderServerPlaceholder || $[22] !== type || $[23] !== url) {
        t9 = type === (0, $AF127.SpaceSidebarLinkType).FORGE && !renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            key: id,
            module: link
        }, linkItem, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: link,
            action: ()=>push(url)
        })) : linkItem;
        $[17] = id;
        $[18] = link;
        $[19] = linkItem;
        $[20] = push;
        $[21] = renderServerPlaceholder;
        $[22] = type;
        $[23] = url;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
};

const $68bf5bd74b4d15cf$var$LazySpaceAppsConfiguration = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "s17W3",
    name: "LazySpaceAppsConfiguration",
    loader: async ()=>(await (parcelRequire("eaAed"))).SpaceAppsConfiguration
});
const $68bf5bd74b4d15cf$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "side-navigation.space-apps.header",
        defaultMessage: "Space apps"
    },
    editButtonLabel: {
        id: "side-navigation.space-apps.edit.label",
        defaultMessage: "Edit apps"
    },
    editButtonTooltip: {
        id: "side-navigation.space-apps.edit.tooltip",
        defaultMessage: "Reorder, show and hide apps"
    },
    noAppsMessage: {
        id: "side-navigation.space-apps.no-space-apps.message",
        defaultMessage: "No apps showing in the sidebar"
    }
});
function $68bf5bd74b4d15cf$var$_temp(a) {
    return (0, $cpa7E.isConnectApp)(a);
}
function $68bf5bd74b4d15cf$var$_temp2(a_0) {
    return (0, $cpa7E.isForgeApp)(a_0);
}
function $68bf5bd74b4d15cf$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}
function $68bf5bd74b4d15cf$var$_temp4(link) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68bf5bd74b4d15cf$var$AppLink, {
        key: link.id,
        link: link
    });
}
function $68bf5bd74b4d15cf$var$_temp5() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
module.exports["SpaceApps"] = $68bf5bd74b4d15cf$export$1f48dee9216ef30e;

});

parcelRegister("iKHTh", function(module, exports) {

var $aJT7b = parcelRequire("aJT7b");

const $19720d3977b4df3f$export$d4c4e98c5044dc8 = (0, $aJT7b.List);
module.exports["MenuList"] = $19720d3977b4df3f$export$d4c4e98c5044dc8;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("cpa7E", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9fBoq = parcelRequire("9fBoq");


var $28oQf = parcelRequire("28oQf");


var $jSwpw = parcelRequire("jSwpw");

const $b58a0883d14838f7$export$651e7ee720a56f40 = (spaceKey, links, forgeApps, isSpaceAdmin)=>{
    const forgeAppsMap = forgeApps.reduce((acc, app)=>{
        return acc.set(app.id, app);
    }, new Map());
    const allAppLinks = links.filter((link)=>$b58a0883d14838f7$export$624f6de9302f0d2d(link) && !$b58a0883d14838f7$var$isBuiltInItem(link) || $b58a0883d14838f7$export$967356d6bd08d9d2(link) && forgeAppsMap.has(link.linkIdentifier))// Fill in links for Forge apps
    .map((link)=>{
        if (!$b58a0883d14838f7$export$967356d6bd08d9d2(link)) return link;
        const forgeApp = forgeAppsMap.get(link.linkIdentifier);
        return {
            ...link,
            url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
            title: (0, $9fBoq.extensionTitle)(forgeApp),
            icon: {
                width: null,
                height: null,
                isDefault: null,
                path: forgeApp.properties.icon || ''
            }
        };
    }).sort((a, b)=>Number(a.position) - Number(b.position));
    // Adding forge apps that are not in the links yet
    // This could be possible for new installed forge apps
    const allForgeLinksIds = allAppLinks.filter($b58a0883d14838f7$export$967356d6bd08d9d2).map((link)=>link.linkIdentifier);
    forgeApps.forEach((forgeApp)=>{
        if (!allForgeLinksIds.includes(forgeApp.id)) {
            const forgeAppLink = {
                id: forgeApp.id,
                type: (0, $jSwpw.SpaceSidebarLinkType).FORGE,
                linkIdentifier: forgeApp.id,
                position: 0,
                hidden: false,
                webItemKey: null,
                webItemCompleteKey: null,
                title: (0, $9fBoq.extensionTitle)(forgeApp),
                url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
                styleClass: null,
                icon: {
                    path: forgeApp.properties.icon || '',
                    width: null,
                    height: null,
                    isDefault: null
                },
                iconClass: null,
                canHide: null,
                tooltip: null,
                properties: forgeApp.properties
            };
            allAppLinks.push(forgeAppLink);
        }
    });
    const appsHidden = links.filter(({ webItemCompleteKey: webItemCompleteKey, hidden: hidden })=>webItemCompleteKey === (0, $28oQf.APPS_KEY) && hidden).length > 0;
    const allVisibleAppLinks = allAppLinks.filter((link)=>!link.hidden);
    const shouldRenderSpaceApps = !appsHidden && !(allAppLinks.length == 0 || allVisibleAppLinks.length == 0 && !isSpaceAdmin);
    return {
        allAppLinks: allAppLinks,
        allVisibleAppLinks: allVisibleAppLinks,
        shouldRenderSpaceApps: shouldRenderSpaceApps
    };
};
const $b58a0883d14838f7$export$9d0f88f6a47d6004 = (spaceKey, app)=>{
    return (0, $1NBp8.SPACE_FORGE_APPS).toUrl({
        spaceKey: spaceKey,
        appId: app.appId,
        envId: app.environmentId,
        forgeManifestRoute: app.properties.route
    });
};
const $b58a0883d14838f7$export$624f6de9302f0d2d = (link)=>{
    return link.webItemCompleteKey?.startsWith((0, $28oQf.CONNECT_ADDON_KEY));
};
const $b58a0883d14838f7$export$967356d6bd08d9d2 = (link)=>{
    return link.type === (0, $jSwpw.SpaceSidebarLinkType).FORGE && link.linkIdentifier;
};
const $b58a0883d14838f7$var$isBuiltInItem = (link)=>{
    const builtInItems = [
        (0, $28oQf.ANALYTICS_KEY),
        (0, $28oQf.ANALYTICS_KEY_MODERATE),
        (0, $28oQf.QUESTIONS_KEY),
        (0, $28oQf.DATABASES_KEY)
    ];
    return builtInItems.includes(link.webItemCompleteKey);
};
module.exports["getAllAppLinks"] = $b58a0883d14838f7$export$651e7ee720a56f40;
module.exports["isConnectApp"] = $b58a0883d14838f7$export$624f6de9302f0d2d;
module.exports["isForgeApp"] = $b58a0883d14838f7$export$967356d6bd08d9d2;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("jSwpw", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0f145b4629280bb6$export$3da4364c8f760e48 = /*#__PURE__*/ function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["FORGE"] = "FORGE";
    SpaceSidebarLinkType["PINNED_ATTACHMENT"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PINNED_BLOG_POST"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PINNED_PAGE"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PINNED_SPACE"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PINNED_USER_INFO"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WEB_ITEM"] = "WEB_ITEM";
    return SpaceSidebarLinkType;
}({});
module.exports["SpaceSidebarLinkType"] = $0f145b4629280bb6$export$3da4364c8f760e48;

});

parcelRegister("AF127", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ba401a956958f707$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $ba401a956958f707$export$3da4364c8f760e48 = /*#__PURE__*/ function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["FORGE"] = "FORGE";
    SpaceSidebarLinkType["PINNED_ATTACHMENT"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PINNED_BLOG_POST"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PINNED_PAGE"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PINNED_SPACE"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PINNED_USER_INFO"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WEB_ITEM"] = "WEB_ITEM";
    return SpaceSidebarLinkType;
}({});
module.exports["SpaceSidebarLinkType"] = $ba401a956958f707$export$3da4364c8f760e48;

});

parcelRegister("eaAed", function(module, exports) {

let $a50e1a0d9084e444$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a50e1a0d9084e444$var$load("6buzy"),
    $a50e1a0d9084e444$var$load("inrnE"),
    $a50e1a0d9084e444$var$load("6wr18"),
    $a50e1a0d9084e444$var$load("Wowvf"),
    $a50e1a0d9084e444$var$load("ffEVr"),
    $a50e1a0d9084e444$var$load("hhss7"),
    $a50e1a0d9084e444$var$load("hs6o8")
]).then(()=>parcelRequire('kB13O'));

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("hSRMl", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $6MJBu = parcelRequire("6MJBu");


var $fKAqd = parcelRequire("fKAqd");

const $01a0d0611b8f7cfb$export$3ae94a2503e890a1 = (date)=>{
    if (!date) return '';
    let formattedDate = '';
    try {
        formattedDate = (0, $dWCFT.default)(new Date(date), 'PP kk:mm');
    // eslint-disable-next-line no-unused-vars
    } catch (e) {}
    return formattedDate;
};
const $01a0d0611b8f7cfb$export$774dcca1e8056ce0 = (type, migratedFromConnect)=>{
    if (!type) return;
    const [prefix] = type.split(':');
    if (prefix === 'ac') {
        // If the content has been migrated from Connect to Forge, treat it as Forge
        if (migratedFromConnect === true) return (0, $fKAqd.CustomContentSources).FORGE;
        return (0, $fKAqd.CustomContentSources).CONNECT;
    }
    if (prefix === 'forge') return (0, $fKAqd.CustomContentSources).FORGE;
};
const $01a0d0611b8f7cfb$export$a4c13e4be52c32cc = ({ operations: operations, targetType: targetType })=>(0, (/*@__PURE__*/$parcel$interopDefault($6MJBu)))(operations, {
        targetType: targetType,
        operation: 'delete'
    });
const $01a0d0611b8f7cfb$var$ABSOLUTE_PATH_REGEXP = new RegExp('^([a-z]+:)?//', 'i');
const $01a0d0611b8f7cfb$export$16b26cd5e98d9100 = (module)=>{
    let icon = module?.uiSupport?.icons?.item?.url;
    if (!$01a0d0611b8f7cfb$var$ABSOLUTE_PATH_REGEXP.test(icon)) icon = module?.baseUrl + icon;
    return icon;
};
const $01a0d0611b8f7cfb$export$63d785e75c867daa = (app)=>{
    return `ac:${app.addonKey}:${app.key}`;
};
module.exports["formatDate"] = $01a0d0611b8f7cfb$export$3ae94a2503e890a1;
module.exports["getCustomContentSource"] = $01a0d0611b8f7cfb$export$774dcca1e8056ce0;
module.exports["ableToDeleteCustomContent"] = $01a0d0611b8f7cfb$export$a4c13e4be52c32cc;
module.exports["getIcon"] = $01a0d0611b8f7cfb$export$16b26cd5e98d9100;
module.exports["getCustomContentTypeForConnect"] = $01a0d0611b8f7cfb$export$63d785e75c867daa;

});

parcelRegister("fKAqd", function(module, exports) {
var $3a7ddab342212797$export$d40a5573030af1a9 = /*#__PURE__*/ function(CustomContentSources) {
    CustomContentSources["CONNECT"] = "CONNECT";
    CustomContentSources["FORGE"] = "FORGE";
    return CustomContentSources;
}({});
module.exports["CustomContentSources"] = $3a7ddab342212797$export$d40a5573030af1a9;

});


//# sourceMappingURL=SpaceApps.ab432e1d.js.map
